/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import useForm from 'hooks/useForm';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
  Form,
  Table,
} from 'reactstrap';
// core components
import SystemHeader from 'components/Headers/UserHeader.js';
import { Notification } from 'notification/notification';
import { useHistory, useParams } from 'react-router-dom';
import {
  setUserInfoSave,
  setUserSave,
  getUserById,
  changePassword,
} from 'services/user';
import { Trash } from 'react-bootstrap-icons';
import {
  getAllPermission,
  removePermissionUser,
  createPermissionUser,
} from 'services/permission';
import { SelectItem } from 'components/Form/Select';

const initialStatePassword = {
  oldPassword: '',
  newPassword: '',
};

const initialStateUserInfo = {
  id: null,
  email: '',
  lastName: '',
  firstName: '',
  phoneNumber: '',
  enabled: true,
  lastPasswordResetDate: '',
  permission: [],
};

const initialStatePermissionAll = [
  {
    name: '',
    namePermission: '',
    description: '',
  },
];

const initialStateNewUser = {
  email: '',
  lastName: '',
  firstName: '',
  phoneNumber: '',
  password: '',
};

const User = () => {
  const { id } = useParams();
  const [userInfo, setUserInfo] = useState(
    id === 'new' ? initialStateNewUser : initialStateUserInfo
  );
  const { handleChange, values } = useForm(initialStatePassword);
  const [select, setSelect] = useState('');
  const [permissionAll, setPermissionAll] = useState(initialStatePermissionAll);

  useEffect(() => {
    if (id !== 'new') {
      async function getData() {
        const data = await getUserById(id);
        if (data !== undefined) {
          setUserInfo(data);
        }
      }
      getData();

      async function getPermission() {
        const dataPermission = await getAllPermission();
        if (dataPermission !== undefined) {
          setPermissionAll(dataPermission);
        }
      }
      getPermission();
    }
  }, [id]);

  const setUserInfoDetail = (key, value) => {
    setUserInfo({
      ...userInfo,
      [key]: value,
    });
  };

  const handleChangeUserInfo = (e) => {
    setUserInfoDetail(e.target.getAttribute('name'), e.target.value);
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    const status = await changePassword(values);
    Notification(status);
  };

  const handleChangeUser = async (e) => {
    e.preventDefault();
    if (id === 'new') {
      const { status } = await setUserSave(userInfo);
      if (status === 200) {
        history.push(`/admin/user`);
        return;
      }
      Notification(status);
      return;
    }
    const statusInfo = await setUserInfoSave(userInfo);
    Notification(statusInfo);
  };

  const handleAddPermission = async (e) => {
    e.preventDefault();
    const { permission, id } = userInfo;
    let result;
    if (permission.length > 0) {
      result = permission.filter((value, _) => {
        return value.namePermission === select;
      });
      if (result[0]) {
        Notification(404, 'Permissão já cadastrada');
        return;
      }
    }

    result = permissionAll.filter((value) => {
      return value.namePermission === select;
    });

    if (result.length === 0) {
      Notification(404, 'Por favor, selecione uma opção!');
      return;
    }
    const status = await createPermissionUser(id, result[0]);
    if (status === 200) {
      Notification(status, 'Permissão adicionada com sucesso!');
      permission.push(result[0]);
      setUserInfo({ ...userInfo, permission });
      return;
    }

    Notification(500, 'Por favor, entre em contato com o suporte!');
  };

  const handleRemovePermission = async (e, namePermission) => {
    const { permission } = userInfo;
    const status = await removePermissionUser(id, namePermission);
    if (status === 200) {
      Notification(status, 'Permissão removida com sucesso!');
      let newPermission = permission
        .map((value) => value.namePermission)
        .indexOf(namePermission);
      if (newPermission > -1) {
        permission.splice(newPermission, 1);
      }
      setUserInfo({ ...userInfo, permission });
      return;
    }

    Notification(500, 'Por favor, entre em contato com o suporte!');
  };

  let history = useHistory();

  const handleShowPermission =
    userInfo.permission === undefined || userInfo.permission === 0
      ? null
      : userInfo.permission.map((perm) => {
          return (
            <tr>
              <th scope='row'>{perm.name}</th>
              <td>{perm.description}</td>
              <td>
                <Button
                  color='primary'
                  onClick={(e) =>
                    handleRemovePermission(e, perm.namePermission)
                  }
                  size='sm'
                >
                  <Trash color='white' size={16} /> Remover Permissão
                </Button>
              </td>
            </tr>
          );
        });
  return (
    <>
      <SystemHeader name={userInfo.firstName} />
      <Container className='mt--7' fluid>
        <Row>
          <Col className='order-xl-1' xl=''>
            <Card className='bg-secondary shadow'>
              <CardHeader className='bg-white border-0'>
                <Row className='align-items-center'>
                  <Col xs='8'>
                    <h3 className='mb-0'>Meus dados</h3>
                  </Col>
                  <Col className='text-right' xs='4'>
                    <Button
                      color='primary'
                      onClick={handleChangeUser}
                      size='sm'
                    >
                      Salvar
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className='heading-small text-muted mb-4'>
                    Informações de Usuário
                  </h6>
                  <div className='pl-lg-4'>
                    <Row>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-first-name'
                          >
                            Nome
                          </label>
                          <Input
                            className='form-control-alternative'
                            id='input-first-name'
                            placeholder='First name'
                            type='text'
                            name='firstName'
                            onChange={handleChangeUserInfo}
                            value={userInfo.firstName}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-last-name'
                          >
                            Sobrenome
                          </label>
                          <Input
                            className='form-control-alternative'
                            id='input-last-name'
                            placeholder='Last name'
                            type='text'
                            name='lastName'
                            onChange={handleChangeUserInfo}
                            value={userInfo.lastName}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-email'
                          >
                            Endereço de e-mail:
                          </label>
                          <Input
                            className='form-control-alternative'
                            id='input-email'
                            placeholder='jesse@example.com'
                            type='email'
                            name='email'
                            onChange={handleChangeUserInfo}
                            value={userInfo.email}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className='my-4' />
                  {/* Address */}
                  <h6 className='heading-small text-muted mb-4'>
                    Informações de Contato
                  </h6>
                  <div className='pl-lg-4'>
                    <Row>
                      <Col md='4'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-tel'
                          >
                            Telefone
                          </label>
                          <Input
                            className='form-control-alternative'
                            id='input-address'
                            placeholder='(11) 99999-9999'
                            type='tel'
                            pattern='(\(\d{2}\)\s)?(\d{4,5}\-\d{4})'
                            name='phoneNumber'
                            onChange={handleChangeUserInfo}
                            value={userInfo.phoneNumber}
                          />
                        </FormGroup>
                      </Col>
                      {id === 'new' ? (
                        <>
                          <Col lg='4'>
                            <FormGroup>
                              <label
                                className='form-control-label'
                                htmlFor='input-password'
                              >
                                Senha:
                              </label>
                              <Input
                                className='form-control-alternative'
                                id='input-password'
                                placeholder='**************'
                                type='password'
                                name='password'
                                onChange={handleChangeUserInfo}
                                value={userInfo.password}
                              />
                            </FormGroup>
                          </Col>
                        </>
                      ) : null}
                    </Row>
                  </div>
                  <hr className='my-4' />
                  {/* Address */}
                  {id !== 'new' ? (
                    <>
                      <h6 className='heading-small text-muted mb-4'>
                        Credenciais
                        <Button
                          className='float-right'
                          color='default'
                          onClick={handleChangePassword}
                          size='sm'
                        >
                          Atualizar Senha
                        </Button>
                      </h6>

                      <div className='pl-lg-4'>
                        <Row>
                          <Col md='6'>
                            <FormGroup>
                              <label
                                className='form-control-label'
                                htmlFor='input-old-password'
                              >
                                Senha Antiga
                              </label>
                              <Input
                                className='form-control-alternative'
                                id='input-old-passowrd'
                                placeholder='*************'
                                type='password'
                                name='oldPassword'
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>
                          <Col md='6'>
                            <FormGroup>
                              <label
                                className='form-control-label'
                                htmlFor='input-new-password'
                              >
                                Senha Nova
                              </label>
                              <Input
                                className='form-control-alternative'
                                id='input-new-passowrd'
                                placeholder='*************'
                                type='password'
                                name='newPassword'
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                      {/* TODO: Incluir variável de ambiente para permissoes
                      <h6 className="heading-small text-muted mb-4">
                        Permissões
                      </h6>
                      <div className="pl-lg-4">
                        <Card className="shadow">
                          <CardHeader className="border-0">
                            <Row className="align-items-center">
                              <div className="col">
                                <SelectItem
                                  data={permissionAll}
                                  stateChange={setSelect}
                                />
                              </div>
                              <div className="col text-right">
                                <Button
                                  color="primary"
                                  onClick={handleAddPermission}
                                  size="sm"
                                >
                                  Adicionar Permissão
                                </Button>
                              </div>
                            </Row>
                          </CardHeader>
                          <Table
                            className="align-items-center table-flush"
                            responsive
                          >
                            <thead className="thead-light">
                              <tr>
                                <th scope="col">Permisssão</th>
                                <th scope="col">Descrição</th>
                                <th scope="col">Ação</th>
                              </tr>
                            </thead>
                            <tbody>{handleShowPermission}</tbody>
                          </Table>
                        </Card>
                      </div> */}
                    </>
                  ) : null}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default User;
